<ng-container *ngIf="block">
    <div class="container-alerts d-flex justify-content-center align-items-stretch flex-wrap">
        <!-- alert -->
        <div *ngFor="let alert of block" class="container-alerts__general {{classColumn}}">

            <div
                class="container-alerts__general__alert {{alert.class}} h-100 d-flex flex-column justify-content-between">
                <div>
                    <div class="container-alerts__general__alert__icon icon" *ngIf="alert.icon">
                        <img loading="lazy" src="./assets/images/{{alert.icon}}.svg" alt="icon">
                    </div>
                    <div class="container-alerts__general__alert__title title" *ngIf="alert.titolo">
                        <h3 class="ls-h3-item-title" [innerHTML]="alert.titolo"></h3>
                    </div>
                    <div class="container-alerts__general__alert__description description ls-p"
                        [innerHTML]="helpersService.modifyLinks(alert.testo_formattato, domainWebsite) | safeHtml">
                    </div>
                </div>
                <ng-container *ngIf="alert.link_cta">
                    <div *ngIf="helpersService.verifyLinkExternal(alert.link_cta.url)"
                        class="container-alerts__general__alert__label label">
                        <a [href]="alert.link_cta.url" class="d-flex">
                            <span class="ls-label-small-semibold container-text cursor-pointer {{alert.btn_color}}" *ngIf="alert.label_cta">
                                {{alert.label_cta | uppercase}}
                            </span>
                            <div class="effect-hover" [ngClass]="{
                                'bg-neutral-A1': alert.tipologia_alert === 'Neutro',
                                'bg-success-30': alert.tipologia_alert === 'Successo',
                                'bg-warning-40': alert.tipologia_alert === 'Attenzione',
                                'bg-error-40': alert.tipologia_alert === 'Urgente'
                            }"></div>
                        </a>
                    </div>
                    <a *ngIf="!helpersService.verifyLinkExternal(alert.link_cta.url)"
                        class="container-alerts__general__alert__label label d-flex"
                        [routerLink]="navigationService.splitUrlRouterLink(alert.link_cta.url).path" [queryParams]="navigationService.splitUrlRouterLink(alert.link_cta.url).queryParams">
                        <span class="ls-label-small-semibold container-text cursor-pointer {{alert.btn_color}}" *ngIf="alert.label_cta">
                            {{alert.label_cta | uppercase}}
                            <div class="effect-hover" [ngClass]="{
                                'bg-neutral-A1': alert.tipologia_alert === 'Neutro',
                                'bg-success-30': alert.tipologia_alert === 'Successo',
                                'bg-warning-40': alert.tipologia_alert === 'Attenzione',
                                'bg-error-40': alert.tipologia_alert === 'Urgente'
                            }"></div>
                        </span>
                    </a>
                </ng-container>
            </div>
        </div>
        <!-- end alert -->
    </div>
</ng-container>